import React from 'react';
import { Col, Row } from 'react-bootstrap';
import NavBar from '../components/NavBar';

class TeachingPage extends React.Component {
  render() {

    var delimiter = '\u25CF'

    return (
      <div className="container"> 
        <NavBar activeKey="teaching" />
        <Row className="mb-4"/>
        <Row>
          <Col>
            <h1>Teaching</h1>
            <i>Please see course pages for my course-specific office hours.</i>
            
            <br/><br/>
            
            <h2>Current Courses (Fall 2022)</h2>
            <ul>
              <li><b>CS 123 - Computing Practices, Projects, and People</b> &#9679; <a href="https://harveymuddcollege.instructure.com/courses/614">Canvas</a></li>
            </ul>
            
            <h2>Past Courses</h2>
            <ul>
              <li>CS 5 Gold - Introduction to Computer Science {delimiter} <a href="https://cs.hmc.edu/cs5">Spring 2022, Fall 2021</a></li>
              <li>CS 123 - Computing Practices, Projects, and People {delimiter} Spring 2023</li>
              <li>CS 140/MATH 168 - Algorithms {delimiter} Fall 2022, <a href="https://canvas.instructure.com/courses/2201567">Fall 2020</a>, <a href="https://sites.google.com/g.hmc.edu/cs140sp20/home">Spring 2020</a>, <a href="https://canvas.instructure.com/courses/1650315">Fall 2019</a> </li>
              <li>CS 159 - Natural Language Processing {delimiter} <a href="https://sites.google.com/g.hmc.edu/cs-159-fall-2020/">Fall 2020</a>, <a href="https://sites.google.com/g.hmc.edu/cs159spring2021/home">Spring 2021</a>, <a href="https://sites.google.com/g.hmc.edu/cs159fall2021/">Fall 2021</a></li>
              <li>CS 4820 - Introduction to Algorithms (Cornell, with Prof. &Eacute;va Tardos)  {delimiter} <a href="http://www.cs.cornell.edu/courses/cs4820/2018fa/">Fall 2018</a></li>
              <li>INFO 3350 - Text Mining for History and Literature (Cornell, with Prof. David Mimno)  {delimiter} <a href="https://mimno.infosci.cornell.edu/info3350/">Spring 2016</a> (updated since)</li>
            </ul>
          </Col>
        </Row>
      </div>
    );
  }
}

export default TeachingPage;
